module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/is-object.js
// module id = 49
// module chunks = 1